import { Box, SxProps } from '@mui/material';
import React from 'react';
import { vars } from '../../../Theme';
import { parseDate, showDateTimeFormat } from '../../../util/DataUtils';
import AppTooltip from '../AppTooltip/AppTooltip';

/** Styles for the Box Component. */
const boxSx: SxProps = {
    height: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    px: 0.5,
    py: 0.25,
};

/**
 * Displays a date in a standardised format.
 */
export default ({ date, showTooltipWithTime }: IDateTagProps) =>
    date && (
        <AppTooltip
            title={showDateTimeFormat(date)}
            disableHoverListener={!showTooltipWithTime}
            placement='top-start'
        >
            <Box
                sx={[
                    {
                        fontSize: 12,
                        borderRadius: 1,
                        bgcolor: vars.lightGray,
                    },
                    ...(Array.isArray(boxSx) ? boxSx : [boxSx]),
                ]}
            >
                {parseDate(date)}
            </Box>
        </AppTooltip>
    );

/** Interface that describes the props for a DateTag component. */
export interface IDateTagProps {
    /** Unix Timestamp. */
    date: number | string;
    /** (OPTIONAL) Flag that shows tooltip with time on DateTag. */
    showTooltipWithTime?: boolean;
}
